import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as AsymmetryVariableRangesActions from '../actions/asymmetry-variable-ranges.actions';
import { AsymmetryVariableRangesService } from '../services/asymmetry-variable-ranges.service';
import { AsymmetryVariableRanges } from '@sleipai/sleip-models';

@Injectable()
export class AsymmetryVariableRangesEffects implements OnInitEffects {
  loadAnalysisResultsTextStore$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AsymmetryVariableRangesActions.loadAsymmetryVariableRanges),
      exhaustMap(() =>
        this.asymmetryVariableRangesService.getAsymmetryVariableRanges().pipe(
          map((asymmetryVariableRanges: AsymmetryVariableRanges[]) =>
            AsymmetryVariableRangesActions.loadAsymmetryVariableRangesSuccess({
              data: asymmetryVariableRanges,
            })
          )
        )
      ),
      catchError((error) =>
        of(
          AsymmetryVariableRangesActions.loadAsymmetryVariableRangesFailure({
            error: error,
          })
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private asymmetryVariableRangesService: AsymmetryVariableRangesService
  ) {}

  ngrxOnInitEffects() {
    return AsymmetryVariableRangesActions.loadAsymmetryVariableRanges();
  }
}
